import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import IntegrationCard from '../components/IntegrationCard';
import { integrations } from '../data/integrations';

const IntegrationsPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleContactClick = () => {
    navigate('/#contact');
    window.setTimeout(() => {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="animate-in fade-in duration-700 pt-32 pb-24">
      <section className="mx-auto max-w-5xl px-4 text-center sm:px-6 lg:px-8">
        <div className="mb-8 inline-flex items-center gap-2 rounded-full border border-blue-500/30 bg-blue-500/10 px-4 py-2">
          <SafeIcon name="Link" className="text-blue-400" />
          <span className="text-sm font-bold uppercase tracking-widest text-blue-400">
            Connected workflows
          </span>
        </div>

        <h1 className="text-5xl font-extrabold leading-tight tracking-tight text-white md:text-7xl">
          AutoReception fits your
          <span className="block bg-gradient-to-r from-blue-400 to-emerald-400 bg-clip-text text-transparent">
            existing workflow
          </span>
        </h1>

        <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-slate-400 md:text-xl">
          Connect the tools you already use to turn every answered call into a booked meeting,
          updated calendar, qualified lead, or completed workflow.
        </p>
      </section>

      <section className="mx-auto mt-16 grid max-w-7xl gap-6 px-4 sm:px-6 md:grid-cols-2 lg:grid-cols-3 lg:px-8">
        {integrations.map((integration) => (
          <IntegrationCard key={integration.name} integration={integration} />
        ))}
      </section>

      <section className="mx-auto mt-20 max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <div className="rounded-3xl border border-slate-800 bg-slate-900/70 p-8 shadow-2xl md:p-12">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-500/10">
            <SafeIcon name="CheckCircle" className="text-2xl text-emerald-400" />
          </div>

          <h2 className="mt-6 text-3xl font-bold text-white">Need a custom connection?</h2>

          <p className="mx-auto mt-4 max-w-2xl leading-relaxed text-slate-400">
            Our team can help design the right call, calendar, CRM, and automation workflow for
            your business.
          </p>

          <button
            type="button"
            onClick={handleContactClick}
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-blue-600 px-7 py-3.5 font-bold text-white shadow-[0_0_20px_rgba(37,99,235,0.35)] transition-all hover:bg-blue-500"
          >
            Talk to our team
            <SafeIcon name="ArrowRight" />
          </button>
        </div>
      </section>
    </div>
  );
};

export default IntegrationsPage;